import { useState } from 'react';
import { useTheme } from '@mui/material';
import Box from '@/components/ui/Box/Box';
import Button from '@/components/ui/Button/Button';
import FieldWrapper from '@/components/ui/FieldWrapper/FieldWrapper';
import Paper from '@/components/ui/Paper/Paper';
import TextField from '@/components/ui/TextField/TextField';
import Typography from '@/components/ui/Typography/Typography';
import InvitationStatusForm from '../InvitationStatusForm/InvitationStatusForm';
import type { RepairerDetailsProps } from './IRepairerDetails';
import { styles } from './styles';

const RepairerDetails = ({ repairer, label }: RepairerDetailsProps) => {
    const theme = useTheme();
    const isPendingInvite = Boolean(
        repairer.registration_code || repairer.registrationCode,
    );

    const titleText = repairer.name?.trim()
        ? repairer.name
        : isPendingInvite
            ? 'Pending Invite'
            : `${label} Nickname`;

    const [notes, setNotes] = useState(repairer.notes ?? '');
    const baselineNotes = repairer.notes ?? '';
    const notesDirty = notes !== baselineNotes;

    return (
        <Paper sx={styles.paper}>
            <Typography sx={styles.title}>{titleText}</Typography>
            <Typography sx={styles.sectionLabel}>Details</Typography>
            {isPendingInvite ? (
                <InvitationStatusForm repairer={repairer} />
            ) : (
                <>
                    <Box sx={styles.fields}>
                        <FieldWrapper filled={Boolean(repairer.contact_info?.email)}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={repairer.contact_info?.email ?? ''}
                                disabled
                            />
                        </FieldWrapper>
                        <FieldWrapper filled={Boolean(repairer.contact_info?.phone_number)}>
                            <TextField
                                fullWidth
                                label="Phone"
                                value={repairer.contact_info?.phone_number ?? ''}
                                disabled
                            />
                        </FieldWrapper>
                        <Box>
                            <FieldWrapper filled={Boolean(notes)}>
                                <TextField
                                    fullWidth
                                    label="Notes"
                                    multiline
                                    minRows={2}
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                />
                            </FieldWrapper>
                            <Typography
                                sx={{ fontSize: '12px', color: 'grey.500', mt: 0.5 }}
                            >
                                Notes will be visible to repairers
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={styles.actions}>
                        <Button
                            onClick={() => setNotes(baselineNotes)}
                            disabled={!notesDirty}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            sx={styles.saveBtn(theme)}
                            disabled={!notesDirty}
                        >
                            Save
                        </Button>
                    </Box>
                </>
            )}
        </Paper>
    );
};

export default RepairerDetails;
